// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.verify-btn {
  font-size: 13px !important;
  padding: 2px 5px;
}

.phone-format-info {
  top: 5px;
  position: relative;
}

.edit-phone-field {
  display: inline;
  width: 75%;
  float: left;
}`, "",{"version":3,"sources":["webpack://./src/app/user/modals/editprofile.screen.component.scss"],"names":[],"mappings":"AAAA;EACC,0BAAA;EACA,gBAAA;AACD;;AACA;EACE,QAAA;EACA,kBAAA;AAEF;;AAAA;EACE,eAAA;EACA,UAAA;EACA,WAAA;AAGF","sourcesContent":[".verify-btn {\n\tfont-size: 13px !important;\n\tpadding: 2px 5px;\t\n}\n.phone-format-info {\n  top: 5px;\n  position: relative;\n}\n.edit-phone-field {\n  display: inline;\n  width: 75%;\n  float: left;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
